import { render, staticRenderFns } from "./TruckRevisions.vue?vue&type=template&id=6665ac82&scoped=true&"
import script from "./TruckRevisions.vue?vue&type=script&lang=js&"
export * from "./TruckRevisions.vue?vue&type=script&lang=js&"
import style0 from "./TruckRevisions.vue?vue&type=style&index=0&id=6665ac82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665ac82",
  null
  
)

export default component.exports